import { createContext, useContext, useEffect } from 'react';
import { useLang } from '@/lib/i18n';

const BASE = process.env.REACT_APP_SITE_URL;
const OG_IMAGE = `${BASE}/n3ledge-social.png`;
export const SeoSnapshotContext = createContext(null);
export const DEFAULT_DESCRIPTION = 'N3LEDGE transforms complex financial information into verified, structured and traceable intelligence for institutional financial review.';

export const structuredData = (path, title) => {
  const graph = [
    {'@type':'Organization','@id':`${BASE}/#organization`,name:'N3LEDGE',url:BASE,logo:`${BASE}/favicon.svg`},
    {'@type':'WebSite','@id':`${BASE}/#website`,url:BASE,name:'N3LEDGE',publisher:{'@id':`${BASE}/#organization`},inLanguage:['en','ro']},
  ];
  if(path !== '/') graph.push({'@type':'BreadcrumbList',itemListElement:[{'@type':'ListItem',position:1,name:'N3LEDGE',item:BASE},{'@type':'ListItem',position:2,name:title.split(' | ')[0],item:BASE+path}]});
  return {'@context':'https://schema.org','@graph':graph};
};
export const Seo = ({title,description = DEFAULT_DESCRIPTION,path = '/',type = 'website'}) => {
  const {lang} = useLang();
  const snapshot = useContext(SeoSnapshotContext);
  if(snapshot) Object.assign(snapshot,{title,description,path,type,lang,image:OG_IMAGE,url:BASE+path,schema:structuredData(path,title)});
  useEffect(() => {
    document.title = title;
    const upsert = (key,content,attr='name') => {
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if(!el) { el = document.createElement('meta'); el.setAttribute(attr,key); document.head.appendChild(el); }
      el.setAttribute('content',content);
    };
    upsert('description',description);
    upsert('robots','index, follow');
    for(const [key,value] of Object.entries({title,description,url:BASE+path,type,site_name:'N3LEDGE',image:OG_IMAGE,'image:alt':'N3LEDGE — Verified Financial Intelligence',locale:lang === 'ro' ? 'ro_RO' : 'en_GB'})) upsert(`og:${key}`,value,'property');
    for(const [key,value] of Object.entries({card:'summary_large_image',title,description,image:OG_IMAGE})) upsert(`twitter:${key}`,value);
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if(!canonical) { canonical = document.createElement('link'); canonical.rel = 'canonical'; document.head.appendChild(canonical); }
    canonical.href = BASE+path;
    let schema = document.getElementById('n3ledge-schema');
    if(!schema) { schema = document.createElement('script'); schema.id='n3ledge-schema'; schema.type='application/ld+json'; document.head.appendChild(schema); }
    schema.textContent = JSON.stringify(structuredData(path,title));
  },[title,description,path,type,lang]);
  return null;
};
